//==============================================================================
// External dep.
//==============================================================================
const _ = require("lodash");
//------------------------------------------------------------------------------
// Interal dep.
//------------------------------------------------------------------------------
const channels = require("./app__channels").channels;

//------------------------------------------------------------------------------
// Packages
//------------------------------------------------------------------------------
const googleDisplay = _.find(channels, { channel_short_name: "google-display" });
const googleSearch = _.find(channels, { channel_short_name: "google-search" });
const facebook = _.find(channels, { channel_short_name: "facebook" });
const instagram = _.find(channels, { channel_short_name: "instagram" });
const youtube = _.find(channels, { channel_short_name: "youtube" });
const twitter = _.find(channels, { channel_short_name: "twitter" });
const reddit = _.find(channels, { channel_short_name: "reddit" });
const snapchat = _.find(channels, { channel_short_name: "snapchat" });
const linkedin = _.find(channels, { channel_short_name: "linkedin" });

module.exports = [
  {
    budget: 950,
    minClicks: 570,
    name: "AdSocial Basic-Reach",
    id: "drsp--adsocial-basic-reach",
    nameShort: "B",
    description: "570 Mindestklicks / 30 Tage Laufzeit / Facebook, Instagram",
    color: "#CEE2F3",
    selectedChannels: [facebook, instagram]
  },
  {
    budget: 1300,
    minClicks: 780,
    name: "AdSocial Classic-Reach",
    id: "drsp--adsocial-classic-reach",
    nameShort: "C",
    description: "780 Mindestklicks / 30 Tage Laufzeit / Facebook, Google Display",
    color: "#CEE2F3",
    selectedChannels: [facebook, googleDisplay]
  },
  {
    budget: 1800,
    minClicks: 1080,
    name: "AdSocial Premium-Reach",
    id: "drsp--adsocial-premium-reach",
    nameShort: "P",
    description: "1080 Mindestklicks / 30 Tage Laufzeit / Facebook, Instagram, YouTube",
    color: "#CEE2F3",
    selectedChannels: [facebook, instagram, youtube]
  },
  {
    budget: 700,
    minClicks: 280,
    name: "Facebook Einzelbuchung",
    id: "drsp--facebook-einzelbuchung",
    nameShort: "FB",
    description: "280 Mindestklicks / 30 Tage Laufzeit / Facebook",
    color: "#B0D59D",
    selectedChannels: [facebook]
  },
  {
    budget: 700,
    minClicks: 280,
    name: "Instagram Einzelbuchung",
    id: "drsp--instagram-einzelbuchung",
    nameShort: "I",
    description: "280 Mindestklicks / 30 Tage Laufzeit / Instagram",
    color: "#B0D59D",
    selectedChannels: [instagram]
  },
  {
    budget: 800,
    minClicks: 320,
    name: "Snapchat Einzelbuchung",
    id: "drsp--snapchat-einzelbuchung",
    nameShort: "S",
    description: "320 Mindestklicks / 30 Tage Laufzeit / Snapchat",
    color: "#B0D59D",
    selectedChannels: [snapchat]
  },
  {
    budget: 700,
    minClicks: 280,
    name: "Reddit Einzelbuchung",
    id: "drsp--reddit-einzelbuchung",
    nameShort: "R",
    description: "280 Mindestklicks / 30 Tage Laufzeit / Reddit",
    color: "#B0D59D",
    selectedChannels: [reddit]
  },
  {
    budget: 800,
    minClicks: 320,
    name: "YouTube Einzelbuchung",
    id: "drsp--youtube-einzelbuchung",
    nameShort: "Y",
    description: "320 Mindestklicks / 30 Tage Laufzeit / YouTube",
    color: "#B0D59D",
    selectedChannels: [youtube]
  },
  {
    budget: 1400,
    minClicks: 560,
    name: "Google Einzelbuchung",
    id: "drsp--google-einzelbuchung",
    nameShort: "G",
    description: "560 Mindestklicks / 30 Tage Laufzeit / Google Display & Google Suche",
    color: "#B0D59D",
    selectedChannels: [googleDisplay, googleSearch]
  },

  {
    budget: 1000,
    minClicks: 400,
    name: "AdSocial - Focus IT",
    id: "drsp--adsocial-focus-it",
    nameShort: "IT",
    description: "400 Mindestklicks / 30 Tage Laufzeit / Twitter, Reddit, LinkedIn",
    color: "#EAD1DB",
    selectedChannels: [twitter, reddit, linkedin]
  },

  {
    budget: 800,
    minClicks: 320,
    name: "AdScoial - Focus Azubi",
    id: "drsp--adsocial-focus-azubi",
    nameShort: "AZ",
    description: "320 Mindestklicks / 30 Tage Laufzeit / Instagram, Snapchat, YouTube",
    color: "#EAD1DB",
    selectedChannels: [instagram, snapchat, youtube]
  },

  {
    budget: 1100,
    minClicks: 660,
    name: "AdSocial - Focus Pflege",
    id: "drsp--adsocial-focus-pflege",
    nameShort: "PF",
    description: "660 Mindestklicks / 30 Tage Laufzeit / YouTube, Facebook, Google Display",
    color: "#EAD1DB",
    selectedChannels: [youtube, facebook, googleDisplay]
  },

  {
    budget: 750,
    minClicks: 450,
    name: "AdSocial - Focus Blue Collar",
    id: "drsp--adsocial-focus-blue-collar",
    nameShort: "BC",
    description: "YouTube, Facebook, Google Search / 450 Mindestklicks / 30 Tage Laufzeit",
    color: "#EAD1DB",
    selectedChannels: [youtube, facebook, googleSearch]
  },
  {
    budget: 1000,
    minClicks: 600,
    name: "AdSocial - Focus Marketing",
    id: "drsp--adsocial-focus-marketing",
    nameShort: "M",
    description: "Instagram, Snapchat, Twitter, LinkedIn / 600 Mindestklicks / 30 Tage Laufzeit",
    color: "#EAD1DB",
    selectedChannels: [instagram, snapchat, twitter, linkedin]
  }
];
